<div class="row full-height">
  <div class="col-md-12 col-sm-12">
    <form #moveToInfluencerGroup="ngForm" class="move-influencer-from-group-form d-flex" novalidate (ngSubmit)="addInfluencersToGroup()">
      <div class="d-flex flex-auto flex-column">
        <div class="bottombar-buttons">
          <button class="button red" (click)="backToPreviewInfluencer()">{{'common.btn.back' | translate}}</button>
          <button class="button green pull-right" type="submit">{{'common.btn.save_group' | translate}}</button>
        </div>
        <div class="bottombar-content move-group-form-content flex-auto">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="left-side">
                <div class="material-field field-button">
                  <achoo-filter-box label="{{'group_details.move_influencer.group_name' | translate}}"
                                    [options]="influencerGroupList"
                                    placeholder="{{'group_details.move_influencer.dropdown_placeholder' | translate}}"
                                    (selectEvent)="onSelectGroup($event)"
                                    [(model)]="influencerGroup.influencer_group_id">
                  </achoo-filter-box>
                  <div class="create-new-group-btn">
                    <button class="button add-icon-btn" (click)="createNewGroup()">{{'group_details.new_group_button' | translate}}</button>
                  </div>
                </div>
                <div class="material-field" *ngIf="hasDescription()">
                  <achoo-material-textarea [numberCol]="3"
                                           placeholder="{{'group_details.move_influencer.text_placeholder' | translate}}"
                                           [(model)]="influencerGroup.description"
                                           [disabled]="true"
                                           label="{{'group_details.move_influencer.description' | translate}}">
                  </achoo-material-textarea>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <send-to-review #AddInfluencerForReview (changeReviewerEvent)="onChangeSelectedReviewers($event)"></send-to-review>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/move-influencer-from-group/move-influencer-from-group.component.html